/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {DatabagRouteMatch} from "../../routing/routes";
import {useLocation, useNavigate, useParams} from "react-router";
import {useStores} from "../../stores";
import {RouteWrapperProps} from "./RouteWrapperProps";
import {reaction} from "mobx";
import {SingleDatabagWrapped} from "./base/SingleDatabagWrapped";

/**
 * Wrapper for the merge2 product offering
 */
export const Merge2EnvWrapper: React.FC<RouteWrapperProps> = observer(({children, state}) => {
    const {
        rootAppStore,
        authStore,
        bagStore,
        bagLoadingStore,
        supplierNormalizationStore,
        masterSupplierNormalizationStore,
        taxonomyManagerStore,
        taxonomySuggestorStore,
        p
    } = useStores();
    const params = useParams<DatabagRouteMatch>();
    const location = useLocation();
    const navigate = useNavigate();
    const isNoData = state.dataType === 'no_data';

    // TODO: See if this can be optimized, probably by the usage of react Context
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Beware: This can cause the page to be rendered with the previous state, we have to be resilient against this
    useEffect(() => rootAppStore.setApp(state), [])

    // The magic that loads the data
    useEffect(() => {
        taxonomySuggestorStore.setSelectedNodeLabel(undefined)
        taxonomySuggestorStore.setSelectedNodeValues(undefined)
        if (!p.p.hardcodeMasterBagId) throw new Error('No hardcoded hardcodeMasterBagId provided');

        // noinspection JSUnusedLocalSymbols
        const disposer = reaction(
            () => [bagStore.bagId, rootAppStore.app.dashboardEnvironment, bagStore.bag?.taxonomy_size] as const,
            ([bagId, dashboardEnvironment, taxonomySize]) => {
                if (p.p.hackNSuppliersFromCommonSuppliers && bagId)
                    supplierNormalizationStore.init(bagId, false)

                if (p.p.hardcodeMasterBagId && bagId && bagId === p.p.hardcodeMasterBagId)
                    masterSupplierNormalizationStore.isMaster = true;
            })

        if (!isNoData) {
            bagLoadingStore.initBag(location, navigate, params)
            authStore.loadUsers()

            // Overwrite the taxonomy for the categorization store
            // Each Taxonomy Editor uses loads in its own taxonomy
            taxonomyManagerStore.setDesiredTaxonomyId(p.p.masterTaxonomyId);

            // bagLoadingStore.loadBagWithoutLoadingStores(p.p.hardcodedSubsidiaryBagId).then(bag => {
            //     console.log(`Wrapper: Bag ${p.p.hardcodedBagId} loaded`);
            //     cmpStore.setCompareBag(bag);
            // });
        }
        return () => disposer();
    }, [])

    return <SingleDatabagWrapped state={state}>{children}</SingleDatabagWrapped>;
});
